import React from 'react';
import {
  Link,
  Grid,
  MaterialIcons,
  Body,
  MaterialUICore,
  Checkbox,
} from '@iclinic/design-system';

import { useStyles } from './styles';

const { FormControl, FormHelperText } = MaterialUICore;
const { Help } = MaterialIcons;

type Props = {
  checked: boolean;
  error: boolean;
  helperText?: string;
  onChange:
    | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
    | undefined;
};

export default function Terms({ checked, error, helperText, onChange }: Props) {
  const classes = useStyles();

  return (
    <>
      <Grid item>
        <FormControl error={error}>
          <Checkbox
            className={classes.checkbox}
            name="terms"
            checked={checked}
            onChange={onChange}
            formControlLabelProps={{
              className: classes.checkboxLabel,
            }}
            label={
              <Body variant="xs">
                Li e aceito os termos de uso do{' '}
                <Link
                  href="https://suporte.iclinic.com.br/pt-br/iclinic-pay/"
                  target="_blank"
                  variant="body2"
                  bold
                >
                  Afya Pay
                </Link>{' '}
                e do{' '}
                <Link
                  href="https://suporte.iclinic.com.br/pt-br/termo-de-ades%C3%A3o-e-condi%C3%A7%C3%B5es-de-uso-do-servi%C3%A7o-de-antecipa%C3%A7%C3%A3o-de-receb%C3%ADveis-de-consultas/"
                  target="_blank"
                  variant="body2"
                  bold
                >
                  Receba Antecipado
                </Link>
                .
              </Body>
            }
          />
          {error && <FormHelperText error>{helperText}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid alignItems="center" wrap="nowrap" item container>
        <Grid item className={classes.helpWrap}>
          <Help className={classes.helpIcon} />
        </Grid>
        <Grid item>
          <Body variant="xs">
            Tire suas dúvidas com nossos especialistas pelo chat ou pelo{' '}
            <Link
              href="https://suporte.iclinic.com.br/pt-br/afya-pay"
              target="_blank"
              variant="body2"
              bold
            >
              FAQ
            </Link>
          </Body>
        </Grid>
      </Grid>
    </>
  );
}
